(function () {
  angular
    .module('kareo.ui.shared.directives.validation.k-valid-dateofbirth', [])
    .directive('kValidDateofbirth', kValidDateofbirth);

  kValidDateofbirth.$inject = [];

  function kValidDateofbirth() {
    return {
      link,
      require: 'ngModel'
    };

    function link(scope, elem, attr, ngModel) {
      var startingDate = moment('01011900', 'MMDDYYYY');
      ngModel.$validators.dateofbirth = function (modelValue) {
        // All birthdates should be after 01/01/1900
        var dob = moment(modelValue, 'MMDDYYYY');
        var isValidDate = dob.isSame(startingDate) || dob.isAfter(startingDate);
        var isBeforeToday = dob.isSameOrBefore(moment(), 'day');

        return ngModel.$isEmpty(modelValue) || (dob.isValid() && isValidDate && isBeforeToday);
      };
    }
  }
})();
